const paymentTypeConstants = {
  APPLE_PAY: 'applePay',
  APPLE_PAY_EXPRESS: 'applePayExpress',
  BUSINESS_ACCOUNT_CARD_BIN_RANGE: '635629',
  CREDIT_CARD: 'creditCard',
  GIFT_CARD: 'giftCard',
  GIFT_OPTIONS: 'giftOptions',
  GIFT_VOUCHER: 'giftVoucher',
  GOOGLE_PAY: 'googlePay',
  KLARNA: 'klarna',
  LINK: 'link',
  OLD_PARTNERSHIP_BIN_RANGE: '542011',
  ONE4ALL_CARD_BIN_RANGE: '484426',
  PAYPAL: 'payPal',
  PAYPAL_PAY_LATER: 'payPalPayLater',
  PAYPAL_EXPRESS: 'paypalExpress',
  POS_CREDIT: 'posCredit',
  POS_CREDIT_PAYMENT_HOLIDAY: 'PAYMENT_HOLIDAY',
  PREPAID_CARD: 'prepaidCard',
  PROMO_CODE: 'promoCode',
  SAVED_PAYMENT_CARD: 'savedPaymentCard',
  TOKENIZED_PAYMENT_CARD: 'tokenizedPaymentCard',
} as const;

export default paymentTypeConstants;
